import {StyledInputLabelWrapper} from "../../components/input/input.style";
import type {FormFieldProps} from "./types";

export function FormField({id, label, renderInput, infoTip}: FormFieldProps) {
  const labelId = label ? `${id}-label` : undefined;

  return (
    <div>
      {label && (
        <StyledInputLabelWrapper>
          <label id={labelId} htmlFor={id}>
            <>
              {label} {infoTip && infoTip()}
            </>
          </label>
        </StyledInputLabelWrapper>
      )}
      <div>{renderInput(labelId)}</div>
    </div>
  );
}

export function FormFieldError({errorMessage}: {errorMessage: string | undefined}) {
  return (
    <>
      {errorMessage ? (
        <div style={{fontSize: "1.4rem", color: "#ff4d4f"}} role="alert">
          {errorMessage}
        </div>
      ) : null}
    </>
  );
}
export function FormFieldHelperText({text}: {text: string}) {
  return <p style={{fontSize: "1.2rem", color: "#595959"}}>{text}</p>;
}
